// extracted by mini-css-extract-plugin
export default {"StackContainer":"Stack_StackContainer__pOHXE","StackImgContainer":"Stack_StackImgContainer__mVgnG"};